import React from "react";

import { cn } from "../../../common/u1/cn";
import { ChevronRight } from "../../../../assets/ui/icons";

/* The "Add Ownership Business › Select Business" chip at the top of a multi-step dialog. */
export const DialogBreadcrumb = ({ prev, next, onBack, className = "" }) => (
  <nav
    aria-label="Dialog steps"
    className={cn(
      "inline-flex items-center gap-1.5 rounded-lg bg-[var(--slate-2)] px-3 py-2",
      className
    )}
  >
    <button
      type="button"
      onClick={onBack}
      className={cn(
        "rounded text-[12.5px] font-bold text-[var(--ink)] font-sans",
        "hover:underline focus-visible:outline-none focus-visible:ring-2",
        "focus-visible:ring-[var(--coral)]"
      )}
    >
      {prev}
    </button>
    <ChevronRight size={11} className="text-[var(--muted-2)]" />
    <span aria-current="step" className="text-[12.5px] font-semibold text-[var(--muted)] font-sans">
      {next}
    </span>
  </nav>
);

export default DialogBreadcrumb;
